module.exports = __webpack_public_path__ + "static/media/item2.8779dd15.jpg";